import React from 'react';
import { bonuses } from '../data/bonuses';
import { SectionLabel } from './ui/SectionLabel';
const BONUS_SET = 'https://cdn.magicpatterns.com/uploads/wuManNq1BiJW4hx43im6jc/ChatGPT_Image_6_sept_2026,_20_04_18.png';
export function BonusesSection() {
  return <section className="w-full bg-ivory py-10 sm:py-14 lg:py-20" aria-labelledby="bonuses-heading" data-id="element-3" data-mp="vqjlj853zgsm">
      <div className="mx-auto w-full max-w-content px-5 sm:px-8" data-id="element-4" data-mp="qw5vzmd4o3vv">
        <div className="mx-auto max-w-2xl text-center" data-id="element-5" data-mp="14rzvjes0hgwb">
          <div className="flex justify-center" data-id="element-6" data-mp="zv13r2vtlm1a">
            <SectionLabel data-id="element-7" data-mp="zu7t3qtqqcdv">Also included</SectionLabel>
          </div>
          <h2 id="bonuses-heading" className="mt-3 font-serif text-[1.6rem] font-semibold uppercase leading-[1.08] text-ink sm:text-4xl" data-id="element-8" data-mp="1eice51g9mzzt">
            And there’s more.
            <span className="block text-forest" data-id="element-9" data-mp="1nl3r55osi3tk">5 premium teaching resources included.</span>
          </h2>
          <p className="mx-auto mt-3 max-w-xl text-[0.9rem] leading-snug text-muted sm:text-base" data-id="element-10" data-mp="1jjryssej74ho">
            Practical resources that support how you teach, communicate and grow your practice — the
            120-class library remains the heart of the system.
          </p>
        </div>

        <img src={BONUS_SET} alt="The five premium bonus resources included with Yoga Teacher System: Yoga Business Starter Guide, Yoga Cueing & Transition Scriptbook, Yoga Student Retention Playbook, Yoga Business & Social Media Playbook and Yoga Studio & Collaboration Guide" className="mx-auto mt-6 w-full max-w-3xl" width={1800} height={900} loading="lazy" data-id="element-11" data-mp="2kkqsnjqf7y1" />

        <ul className="mt-6 grid grid-cols-2 gap-2.5 sm:gap-3 lg:grid-cols-3" data-id="element-12" data-mp="lcvnfznsm9np">
          {bonuses.map((bonus, index) => {
          const isLast = index === bonuses.length - 1;
          return <li key={bonus.number} className={isLast ? 'col-span-2 flex h-full items-center justify-center gap-4 rounded-2xl border border-sandDark bg-cream/70 px-4 py-3.5 text-left lg:col-span-1 lg:flex-col lg:gap-1.5 lg:px-3 lg:py-4 lg:text-center' : 'flex h-full flex-col items-center gap-1.5 rounded-2xl border border-sandDark bg-cream/70 px-3 py-4 text-center'} data-id="element-13" data-mp="v86vy08lykn0" data-mpi={index}>
                {isLast ? <>
                    <span className="shrink-0 text-[0.55rem] font-semibold uppercase tracking-label text-gold lg:shrink" data-id="element-14" data-mp="taxfmkx991qi">
                      Bonus {bonus.number}
                    </span>
                    <span className="min-w-0 lg:contents" data-id="element-15" data-mp="13afuwo27zzc8">
                      <span className="block font-serif text-[0.8rem] font-semibold uppercase leading-tight text-ink sm:text-[0.95rem]" data-id="element-16" data-mp="137tnqpj8rluj">
                        {bonus.title}
                      </span>
                      <span className="mt-0.5 block text-[0.75rem] leading-snug text-muted sm:text-[0.85rem] lg:mt-0" data-id="element-17" data-mp="35343ze1jpgzx">
                        {bonus.short}
                      </span>
                    </span>
                  </> : <>
                    <span className="text-[0.55rem] font-semibold uppercase tracking-label text-gold" data-id="element-18" data-mp="1kip3o1t54vg0">
                      Bonus {bonus.number}
                    </span>
                    <span className="font-serif text-[0.8rem] font-semibold uppercase leading-tight text-ink sm:text-[0.95rem]" data-id="element-19" data-mp="1asdr5qve5dxi">
                      {bonus.title}
                    </span>
                    <span className="text-[0.75rem] leading-snug text-muted sm:text-[0.85rem]" data-id="element-20" data-mp="10vhpo53wts2g">
                      {bonus.short}
                    </span>
                  </>}
              </li>;
        })}
        </ul>
      </div>
    </section>;
}